import { motion } from "framer-motion";

const CHAPTERS = [
  {
    n: "01",
    kicker: "Градът се променя",
    title: "Варна привлича капитал.",
    body:
      "Ново строителство, инвестиционен интерес и променящ се профил на купувача. Градът навлиза в нов цикъл — и решенията, взети в следващите 12 месеца, ще определят следващото десетилетие.",
  },
  {
    n: "02",
    kicker: "На едно място",
    title: "Инвеститори · строители · брокери.",
    body:
      "Създаваме място, където хората, които реално движат пазара, се събират. Отваряме мрежите. Правим възможни разговорите, които обикновено се случват на затворени врати.",
  },
  {
    n: "03",
    kicker: "Отвъд теорията",
    title: "Кои райони. Кои проекти. Кои стратегии.",
    body:
      "Говорим открито за пазара във Варна и България — къде има потенциал, кои проекти ще определят следващите години, и кои стратегии работят в новата реалност.",
  },
];

export default function Manifesto() {
  return (
    <section
      id="manifesto"
      data-testid="manifesto-section"
      className="relative py-24 sm:py-32 lg:py-40 bg-[#0B1F3D] text-[#F5EBD9]"
    >
      <div className="max-w-[1440px] mx-auto px-6 sm:px-10 lg:px-16">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.9 }}
          className="mb-20 lg:mb-28"
        >
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-10 bg-[#F5892E]" />
            <span className="font-mono text-[11px] uppercase tracking-[0.32em] text-[#F5EBD9]/70">
              Манифест — Три глави
            </span>
          </div>
          <h2 className="font-display uppercase text-4xl sm:text-5xl lg:text-6xl max-w-[18ch] leading-[1.02]">
            Защо това събитие. <span className="text-[#F5892E]">Защо сега.</span>
          </h2>
        </motion.div>

        <div className="space-y-24 lg:space-y-32">
          {CHAPTERS.map((c, i) => (
            <motion.article
              key={c.n}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.35 }}
              transition={{ duration: 0.9, delay: i * 0.05, ease: [0.2, 0.8, 0.2, 1] }}
              className="grid grid-cols-12 gap-6 lg:gap-10 border-t border-[#F5EBD9]/15 pt-10"
              data-testid={`chapter-${c.n}`}
            >
              <div className="col-span-12 md:col-span-3">
                <div className="chapter-num text-7xl sm:text-8xl lg:text-9xl leading-none">
                  {c.n}
                </div>
                <div className="mt-2 font-mono text-[11px] uppercase tracking-[0.32em] text-[#F5EBD9]/60">
                  {c.kicker}
                </div>
              </div>
              <div className="col-span-12 md:col-span-9 lg:col-span-8 lg:col-start-5">
                <h3 className="font-display uppercase text-3xl sm:text-4xl lg:text-5xl mb-6 leading-[1.05]">
                  {c.title}
                </h3>
                <p className="text-lg sm:text-xl text-[#F5EBD9]/70 leading-relaxed max-w-[62ch]">
                  {c.body}
                </p>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
